import Data from './Data';

const TestimonialsSidebar = (props: any) => {
  return <Data {...props} />;
};

export default TestimonialsSidebar;
